const realbaseApplications = [
  {
    key: 'aim-digital', value: 'AIM Digital',
  },
  {
    key: 'campaigntrack', value: 'Campaigntrack',
  },
  {
    key: 'contenthouse', value: 'ContentHouse',
  },
  {
    key: 'engage', value: 'Engage',
  },
  {
    key: 'my-accounts', value: 'MyAccounts',
  },
  {
    key: 'realhub', value: 'Realhub',
  },
]

export default realbaseApplications
